module.exports = __webpack_public_path__ + "static/media/template2-carousel.4d58284a.png";